
import * as types from './mutation-types'
import Ls from '@/services/ls'


// Garde de route, layout et écrans la demandent au même chargement : un seul appel, et la
// réponse est réutilisée 10 s pour le même compte (jeton) — un changement de rôle ou de
// compte reste pris en compte presque aussitôt
const PERMISSIONS_REUSE_MS = 10000
let permissionsRequest = null
let permissionsFetchedAt = 0
let permissionsToken = null

export const loadPermissions = ({ commit, dispatch, state }) => {
    const token = Ls.get('auth.token')
    if (permissionsRequest && token === permissionsToken && Date.now() - permissionsFetchedAt < PERMISSIONS_REUSE_MS) {
        return permissionsRequest
    }
    permissionsToken = token
    permissionsFetchedAt = Date.now()
    permissionsRequest = new Promise((resolve, reject) => {
        window.axios.get('get/permissions').then((response) => {
            commit(types.ADD_PERMISSIONS, response.data.permissions)
            commit(types.SET_SHOP_PERMISSIONS, response.data.shop_permissions)
            resolve(response)
        }).catch((err) => {
            permissionsRequest = null
            reject(err)
        })
    })
    return permissionsRequest
}

export const loadPermissionLabels = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('permissions/labels').then((response) => {
            commit(types.SET_PERMISSION_LABELS, response.data.labels)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


